import { ReactComponent as ComingSoonImage } from '@backrs_ui/common-ui/src/assets/images/coming-soon.svg';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { appStrings } from '../assets/appStrings';
import { TYPOGRAPHY_VARIANTS } from '../designSystem/typography/typography';

const COMING_SOON_STRINGS = appStrings.modules.comingSoon;

export const ComingSoon = () => {
  return (
    <Box sx={containerSx}>
      <Box sx={imageContainerSx}>
        <ComingSoonImage />
      </Box>

      <Typography sx={comingSoonTextSx} variant="display-xl-medium">
        {COMING_SOON_STRINGS.title}
      </Typography>
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100svh',
  gap: { xs: '2rem', sm: '4rem' },
  width: '100%',
} as const;

const comingSoonTextSx: SxProps<Theme> = {
  textAlign: 'center',
  fontSize: {
    xs: '32px',
    sm: TYPOGRAPHY_VARIANTS['display-xl-medium'].fontSize,
  },
} as const;

const imageContainerSx: SxProps<Theme> = {
  svg: {
    width: '100%',
    height: '100%',
  },
} as const;
